module.exports = "/Message@2x-99cc1c5a1d5aa18c3eb2ecdcc23bf4ea.png";